import React, { useState } from 'react';
import HeaderWithoutLang from '../HeaderWithoutLang';
import Footer from '../Footer';
import FAQAccordion from './FAQAccordi0n';
const sections = [
  {
    id: 'info-we-collect',
    icon: "/images/intro-icon.png",
    title: 'Introduction',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>At GrowBizh, we value your trust. While we aim to deliver seamless services, we understand issues may arise. This grievance redressal process ensures your complaints are heard and resolved efficiently.</p></div>
        
      </>
    ),
  },
  {
      id: "grievance-process",
      title: "Our Grievance Redressal Process",
      icon: "/images/grievance-process-icon.png",
      content: (
        <div className="grievance-process-section">
          <div className="grievance-process-step step1">
            <div className="grievance-step-title">Step 1 : Reach Out to Customer Support</div>
            <div className="grievance-step-description">If you're facing any issue or have a concern, start by contacting our support team:</div>
            <ul className="grievance-step-list">
              <li>Email : <span>support@growbizh.com</span></li>
              <li>Phone : 9898049602</li>
              <li>Response Time : Within 48 working hours</li>
            </ul>
          </div>
          <div className="grievance-process-step step2">
            <div className="grievance-step-title">Step 2: Escalate to the Grievance Officer</div>
            <div className="grievance-step-description">If your issue remains unresolved or you're unsatisfied with the support response, you may escalate it to our designated Grievance Officer:</div>
            <ul className="grievance-step-list">
              <li>Grievance Officer: [Officer Name]</li>
              <li>Email : <span>support@growbizh.com</span></li>
              <li>Phone : 9898049602</li>
              <li>Address : SMILe – Digital & AI Lab,World Trade Center, Eon Free Zone Rd,Kharadi, Pune, Maharashtra 411014
              </li>
            </ul>
          </div>
          <div className="grievance-process-step step3">
            <div className="grievance-step-title">Step 3: Resolution Timelines</div>
            <div className="grievance-step-description">If your issue remains unresolved or you're unsatisfied with the support response, you may escalate it to our designated Grievance Officer:</div>
            <ul className="grievance-step-list">
              <li>Acknowledgement of complaint: Within 48 working hours</li>
              <li>Final resolution: Within 7 working days from the date of complaint receipt</li>
            </ul>
          </div>
        </div>
      ),
    },
  {
    id: "grievance-rights",
    title: "Your Rights as a User",
    icon: "/images/user-rights-icon.png",
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>You have the right to:</p></div>
        <div className="privacy-policy-indent">
          <ul>
          <li>Request updates on your complaint status</li>
            <li>Modify or withdraw your complaint</li>
            <li>Refuse marketing communications</li>
            <li>Approach the appropriate regulatory authority if unsatisfied with our resolution</li>
          </ul>
        </div>
      </>
    ),
  },
  {
    id: "grievance-submit",
      title: "How to Submit a Complaint",
      icon: "/images/submit-complain-icon.png",
    content: (
      <>
      <div className="privacy-policy-indent-shift"><p>You can submit your grievance via any of the following:</p></div>
      <div className="privacy-policy-indent">
        <ul>
        <li>Email : <a href="mailto:support@growbizh.com" className="grievance-submit-complaint-link">support@growbizh.com</a></li>
        <li>Phone : 9898049602</li>
        </ul>
      </div>
    </>
    ),
  },
  {
    id: "grievance-faq",
    title: "Frequently Asked Questions",
    icon: "/images/faq-icon.png",
    content: <FAQAccordion />,
  },
  {
    id: 'disclaimer',
    title: "Disclaimer",
    icon: "/images/disclaimer-icon.png",
    content: (
      <div className="privacy-policy-indent-shift">
        This Grievance Policy may be updated from time to time. Any changes will be posted here with an updated effective date.
      </div>
    ),
  },
  {
    id: 'contact',
    icon: '/images/contact.svg',
    title: 'Contact Us',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>For any questions or concerns about this policy, contact us at:</p></div>
        <div className="privacy-policy-indent">
          <ul className="privacy-policy-list-no-bullet">
            <li><span style={{fontWeight:600}}>GrowBizh</span></li>
            <li><span style={{fontWeight:600}}>Phone:</span> <a href="tel:9988049602">9988049602</a></li>
            <li><span style={{fontWeight:600}}>Office Address:</span> SMILE – Digital & AI Lab World trade center, Eon free zone rd, Kharadi , Pune, Maharashtra 411014</li>
            <li><span style={{fontWeight:600}}>Website:</span> <a href="https://growbizh.com" target="_blank" rel="noopener noreferrer">https://growbizh.com</a></li>
          </ul>
        </div>
      </>
    ),
  },
];

function isMobile() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 480;
}

const GrievanceRedressalPage = () => {
  const [openSection, setOpenSection] = useState(isMobile() ? sections[0].id : null);
  const [mobile, setMobile] = useState(isMobile());
  const [showToc, setShowToc] = useState(false);

  React.useEffect(() => {
    function handleResize() {
      setMobile(isMobile());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <HeaderWithoutLang />
      <section className="privacy-policy-hero">
        <div className="privacy-policy-hero-content">
          <h1>Grievance Redressal Mechanism</h1>
          <p> We're committed to addressing your concerns with fairness, transparency, and speed.</p>
        </div>
      </section>
      <section className="privacy-policy-main">
        {mobile ? (
          <div className="privacy-policy-accordion">
            <div className="privacy-policy-toc">
              <span>
                <h3>Table of Contents</h3>
              </span>
              <span>
                <img src="/images/printer.svg" alt="Print Policy" />
                <img src="/images/download-icon.svg" alt="Download PDF" />
                <img 
                  src="/images/Arrow.svg" 
                  alt="Arrow" 
                  style={{
                    width: '19px', 
                    height: '19px',
                    transform: showToc ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease'
                  }}
                  onClick={() => setShowToc(!showToc)}
                />
              </span>
            </div>
            {showToc && (
              <div className="privacy-policy-mobile-toc">
                {sections.map((section) => (
                  <div 
                    key={section.id}
                    onClick={() => {
                      setOpenSection(section.id);
                      setShowToc(false);
                    }}
                    style={{
                      padding: '12px 20px',
                      borderBottom: '1px solid #e6eaf3',
                      cursor: 'pointer'
                    }}
                  >
                    {section.title}
                  </div>
                ))}
              </div>
            )}
            {sections.map((section) => (
              <div className="privacy-policy-accordion-section" key={section.id}>
                <button
                  className="privacy-policy-accordion-title"
                  aria-expanded={openSection === section.id}
                  aria-controls={`section-content-${section.id}`}
                  onClick={() => setOpenSection(openSection === section.id ? null : section.id)}
                  style={{display: 'flex', alignItems: 'center', width: '100%', background: 'none', border: 'none', padding: '16px 0', fontWeight: 600, fontSize: '1.08rem', cursor: 'pointer'}}
                >
                  <img src={section.icon} alt="" className="icon-svg" style={{marginLeft: 0, marginRight: 12}} />
                  <span style={{flex: 1, textAlign: 'left'}}>{section.title}</span>
                  <img
                    src={openSection === section.id ? '/images/arrow-up.svg' : '/images/arrow-down.svg'}
                    alt={openSection === section.id ? 'Collapse' : 'Expand'}
                    className="privacy-policy-accordion-arrow"
                    style={{width: 24, height: 24, marginLeft: 8}}
                  />
                </button>
                {openSection === section.id && (
                  <div
                    className="privacy-policy-accordion-content"
                    id={`section-content-${section.id}`}
                    style={{padding: '0 8px 12px 8px'}}
                  >
                    {section.content}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="privacy-policy-container">
            <aside className="privacy-policy-toc">
              <h3>Table of Contents</h3>
              <ol>
                {sections.map((section) => (
                  <li key={section.id}>
                    <a href={`#${section.id}`}>{section.title}</a>
                  </li>
                ))}
              </ol>
              <div className="privacy-policy-toc-actions">
                <button className="btn-print">
                  <img src="/images/printer.svg" alt="Print Policy" className="toc-action-icon" />
                  Print Policy
                </button>
                <button className="btn-download">
                  <img src="/images/download-icon.svg" alt="Download PDF" className="toc-action-icon" />
                  Download PDF
                </button>
              </div>
            </aside>
            <div className="privacy-policy-content">
              {sections.map((section) => (
                <section id={section.id} className="privacy-policy-section" key={section.id}>
                  <h2><span className={`icon ${section.id}-icon`}><img src={section.icon} alt="" className="icon-svg" /></span> {section.title}</h2>
                  {section.content}
                </section>
              ))}
            </div>
          </div>
        )}
      </section>
      <Footer />
    </>
  );
};

export default GrievanceRedressalPage; 